//exp slider
$('#slickslide').slick({
    dots: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll:3,
    adaptiveHeight: false,

    responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll:3,

            }
        },
        {
            breakpoint: 1088,
            settings: {
                slidesToShow: 2,
                slidesToScroll:2,
                arrows:false,

            }
        },

        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll:1,

            }
        },

        {
            breakpoint: 561,
            settings: {
                slidesToShow: 1,
                slidesToScroll:1,

                infinite: true,
            }
        },

    ]

});

//header stciky

window.onscroll = function() {myFunction()};

var header = document.getElementById("hdrrr");
var sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky-hdr");
  } else {
    header.classList.remove("sticky-hdr");
  }
}


